export const Kurvtyper : {id: string , navn : string}[] = [
    {
        id:'SDO',
        navn: 'Journalposter',
        
    },
    {
        id:'SAS',
        navn: 'ArkivSaker',
        
    },
    {
        id:'NFL',
        navn: 'Oppgaver',
    },
    {
        id:'MIL',
        navn: 'Milepæler',
    },
    {
        id:'LNK',
        navn: 'Linker',
    }
];